<div class="widget-container" *ngIf="widget !== undefined && widget !== null">
    <ng-container *ngFor="let item of widget; let first = first">
        <div class="widget" [class.pb-2]="widget.length > 1 && first" *ngIf="item.desktop_image !== null">
            <!-- X icon -->
            <i class="fas fa-times" (click)="onCloseWidget($event)"></i>
            <!-- widget -->
            <a  *ngIf="item.link !== null && (item.link).includes('http'); else no_http_widget_link" [href]="item.link" target="_blank"><img [src]="item.desktop_image" alt="widget" draggable="false" oncontextmenu="return false;"></a>
            <ng-template #no_http_widget_link>
                <a  *ngIf="item.link !== null && !(item.link).includes('http'); else null_widget_link" [routerLink]="item.link" target="_blank"><img [src]="item.desktop_image" alt="widget" draggable="false" oncontextmenu="return false;"></a>
            </ng-template>
            
            <ng-template #null_widget_link>
                <a  *ngIf="item.error_message !== null; else no_error_widget_link" target="_blank" (click)="onClickWidget(item.error_message)"><img [src]="item.desktop_image" alt="widget"></a>
                <ng-template #no_error_widget_link>
                    <a target="_blank"><img [src]="item.desktop_image" alt="widget"></a>
                </ng-template>
            </ng-template>
        </div>
    </ng-container>
</div>